import axios from 'axios';
import debounce from 'lodash/debounce';
import googleAnalyticsClient from '../common/google_analytics/ajax_handling';
import karteErrorClient from '../common/karte/error';

document.addEventListener('DOMContentLoaded', () => {
  const formDiv = document.getElementById('store_products_form');
  if (formDiv == null) {
    return;
  }

  const productNameInput = document.getElementById('chirashiru_store_product_name') as HTMLInputElement;
  const productImageFileInput = document.getElementById('chirashiru_store_product_image') as HTMLInputElement;
  const productImagesWrapper = document.querySelector('.product-images-wrapper') as HTMLElement;
  const productImageInputArea = document.getElementById('product_image_input_area') as HTMLElement;
  const productIdInput = document.getElementById('chirashiru_store_product_chirashiru_product_id') as HTMLInputElement;
  const imageGalleryIdInput = document.getElementById('chirashiru_store_product_chirashiru_store_product_image_gallery_id') as HTMLInputElement;
  const uploadedProductImage = document.getElementById('uploaded_product_image') as HTMLElement;
  const uploadedProductImageEdit = uploadedProductImage.querySelector('.edit-cover') as HTMLElement;
  const removeImageInput = document.getElementById('chirashiru_store_product_remove_image') as HTMLInputElement;
  const productImagesWrapperOuterForMobile = document.getElementById('product_images_wrapper_outer') as HTMLInputElement;

  type productAttributes = { id: string; image_url: string };
  type resultProducts = { data: Array<productAttributes> };
  type imageGalleryAttributes = { id: string; image_url: string };
  type resultImageGalleries = { data: Array<imageGalleryAttributes> };

  // Productを取得してレンダリングする
  const fetchProducts = () => {
    removeProductImages();
    const name = productNameInput.value;
    if (!name.length) {
      // 単商品名がない場合は処理しない
      return;
    }
    axios
      .get<resultProducts>('/staff/api/products/fetch', {
        params: {
          name,
        },
      })
      .then(response => {
        const data = response.data;
        renderProductImages(data as any);
      })
      .catch(error => {
        // 単品商品の画像マスターを取得する処理でのエラー

        // エラーで使う変数
        const errorPath = '/staff/api/products/fetch';
        const errorMessage = '単品商品の画像マスターを取得する際にエラー発生';
        const el = document.querySelector<HTMLElement>('#staff_infomation');
        const staffId = el?.dataset.staffId;
        const now = el?.dataset.now;

        // エラーイベントを送信 (GA)
        if(staffId && now) {
          googleAnalyticsClient.error({
            time: now,
            path: errorPath,
            staffId: staffId,
            message: errorMessage
          });
        }

        // エラーイベントを送信 (KARTE)
        karteErrorClient.error({
          path: errorPath,
          message: errorMessage
        });
      });
  };

  // ImageGalleriesを取得してレンダリングする
  const fetchImageGalleries = () => {
    removeImageGalleries();
    const name = productNameInput.value;
    if (!name.length) {
      // 単商品名がない場合は処理しない
      return;
    }
    axios
      .get<resultImageGalleries>('/staff/api/chirashiru_store_product_image_galleries/fetch', {
        params: {
          name,
        },
      })
      .then(response => {
        const data = response.data;
        renderImageGalleries(data as any);
      })
      .catch(error => {
        // 単品商品の画像ギャラリーを取得する処理でのエラー

        // エラーで使う変数
        const errorPath = '/staff/api/chirashiru_store_product_image_galleries/fetch';
        const errorMessage = '単品商品の画像ギャラリーを取得する際にエラー発生';
        const el = document.querySelector<HTMLElement>('#staff_infomation');
        const staffId = el?.dataset.staffId;
        const now = el?.dataset.now;

        // エラーイベントを送信 (GA)
        if(staffId && now) {
          googleAnalyticsClient.error({
            time: now,
            path: errorPath,
            staffId: staffId,
            message: errorMessage
          });
        }

        // エラーイベントを送信 (KARTE)
        karteErrorClient.error({
          path: errorPath,
          message: errorMessage
        });
      });
  }

  const renderImageGalleries = (imageGalleries: Array<imageGalleryAttributes>) => {
    [].forEach.call(imageGalleries, imageGallery => {
      const imageGalleryId = imageGallery['id'];
      const imageGalleryName = imageGallery['name'];
      const imageGalleryImageUrl = imageGallery['image_url'];
      const div = document.createElement('div');
      div.classList.add('image-gallery');
      div.dataset.imageGalleryId = imageGalleryId;
      div.dataset.imageGalleryName = imageGalleryName;
      const img = document.createElement('img');
      img.src = imageGalleryImageUrl;
      img.classList.add('image-gallery-img');
      const span = document.createElement('span');
      span.innerText = imageGalleryName;
      div.appendChild(img);
      div.appendChild(span);
      productImagesWrapper.appendChild(div);
      addEventToImageGrallery(div);
      resizeProductImagesWrapperOuter();
    });
  }

  const renderProductImages = (products: Array<productAttributes>) => {
    const registeredProductId = productImagesWrapper.dataset.registeredProductIdForInitialize;
    [].forEach.call(products, product => {
      const productId = product['id'];
      const productName = product['name'];
      const productImageUrl = product['image_url'];
      const div = document.createElement('div');
      div.classList.add('product-image');
      if (registeredProductId && registeredProductId == productId) {
        // すでに登録されている商品画像があれば、それにチェックを入れる (その処理は一度のみ)
        div.classList.add('selected');
        productImagesWrapper.dataset.registeredProductIdForInitialize = '';
      }
      div.dataset.productId = productId;
      const img = document.createElement('img');
      img.src = productImageUrl;
      img.classList.add('product-image-img');
      const span = document.createElement('span');
      span.innerText = productName;
      div.appendChild(img);
      div.appendChild(span);
      productImagesWrapper.appendChild(div);
      addEventToImage(div);
      resizeProductImagesWrapperOuter();
    });
  }

  const removeProductImageSelectedClass = () => {
    // product-imageのselectedを外す
    const productImages = productImagesWrapper.querySelectorAll('.product-image');
    [].forEach.call(productImages, productImage => {
      (productImage as HTMLElement).classList.remove('selected');
    });

    // image-galleryのselectedを外す
    const imageGalleries = productImagesWrapper.querySelectorAll('.image-gallery');
    [].forEach.call(imageGalleries, imageGallery => {
      (imageGallery as HTMLElement).classList.remove('selected');
    });

    // 手動アップロードの画像もselectedを外す
    uploadedProductImage.classList.remove('selected');
  }

  productImageInputArea.addEventListener('click', () => {
    productImageFileInput.click();
  });

  // プレビューを表示
  productImageFileInput.addEventListener('change', () => {
    const image = uploadedProductImage.querySelector('img') as HTMLImageElement;
    const files = productImageFileInput.files;
    if (files && files[0]) {
      const file = files[0];
      const reader = new FileReader();
      reader.addEventListener('load', (e) => {
        if ((e.target as FileReader).result) {
          image.src = (e.target as any).result || '';
          refreshProductImageInputAreaAndUploadedImage();
          removeProductImageSelectedClass();
          uploadedProductImage.classList.add('selected');
          refreshSelectedProductIdAndImageGalleryId();
        }
      });
      // 画像データを読み込む
      reader.readAsDataURL(file);
    }
  });

  const refreshProductImageInputAreaAndUploadedImage = () => {
    const image = uploadedProductImage.querySelector('img') as HTMLImageElement;
    const imageSrc = image.getAttribute('src');
    if (imageSrc == '') {
      uploadedProductImage.style.display = 'none';
      productImageInputArea.style.display = 'inline-block';
    } else {
      uploadedProductImage.style.display = 'inline-block';
      productImageInputArea.style.display = 'none';
    }
  }

  const addEventToImage = (productImage: HTMLElement) => {
    productImage.addEventListener('click', (e) => {
      const targetElement = e.target as HTMLElement;
      if (targetElement.tagName == 'IMG') {
        const parentElement = targetElement.parentElement as HTMLElement;
        if (parentElement.classList.contains('edit-cover')) {
          return;
        }
      }
      if (productImage.classList.contains('selected')) {
        productImage.classList.remove('selected');
        addRemoveProductImageFlag();
      } else {
        removeProductImageSelectedClass();
        productImage.classList.add('selected');
        removeRemoveProductImageFlag();
      }
      refreshSelectedProductIdAndImageGalleryId();
    });
  }

  const addEventToImageGrallery = (imageGallery: HTMLElement) => {
    imageGallery.addEventListener('click', () => {
      if (imageGallery.classList.contains('selected')) {
        imageGallery.classList.remove('selected');
        addRemoveProductImageFlag();
      } else {
        removeProductImageSelectedClass();
        imageGallery.classList.add('selected');
        removeRemoveProductImageFlag();
      }
      refreshSelectedProductIdAndImageGalleryId();
    });
  }

  const removeProductImages = () => {
    const productImages = productImagesWrapper.querySelectorAll('.product-image');
    [].forEach.call(productImages, productImage => {
      (productImage as HTMLElement).remove();
    });
  }

  const removeImageGalleries = () => {
    const imageGalleries = productImagesWrapper.querySelectorAll('.image-gallery');
    [].forEach.call(imageGalleries, imageGallery => {
      (imageGallery as HTMLElement).remove();
    });
  }

  const addRemoveProductImageFlag = () => {
    removeImageInput.value = 'true';
  }

  const removeRemoveProductImageFlag = () => {
    removeImageInput.value = '';
  }

  const refreshSelectedProductIdAndImageGalleryId = () => {
    refreshSelectedProductId();
    refreshSelectedImageGalleryId();
  }

  const refreshSelectedProductId = () => {
    const selectedProductImage = productImagesWrapper.querySelector('.selected') as HTMLElement;
    if (selectedProductImage) {
      if (selectedProductImage.classList.contains('product-image')) {
        // 自動で抽出された画像の場合
        const productId = selectedProductImage.dataset.productId || '';
        productIdInput.value = productId;
      } else if (selectedProductImage.id == 'uploaded_product_image') {
        // 自信がアップロードした画像の場合
        productIdInput.value = '';
      } else {
        // それ以外の場合
        productIdInput.value = '';
      }
    } else {
      productIdInput.value = '';
    }
  }

  const refreshSelectedImageGalleryId = () => {
    const selectedImageGallery = productImagesWrapper.querySelector('.selected') as HTMLElement;
    if (selectedImageGallery) {
      if (selectedImageGallery.classList.contains('image-gallery')) {
        // 自動で抽出された画像の場合
        const imageGalleryId = selectedImageGallery.dataset.imageGalleryId || '';
        imageGalleryIdInput.value = imageGalleryId;
      } else if (selectedImageGallery.id == 'uploaded_product_image') {
        // 自信がアップロードした画像の場合
        imageGalleryIdInput.value = '';
      } else {
        // それ以外の場合
        imageGalleryIdInput.value = '';
      }
    } else {
      imageGalleryIdInput.value = '';
    }
  }

  // モバイル用
  const resizeProductImagesWrapperOuter = () => {
    if (productImagesWrapperOuterForMobile) {
      const imageGalleries = productImagesWrapper.querySelectorAll('.image-gallery');
      const productImages = productImagesWrapper.querySelectorAll('.product-image');
      var outerWidth = 164;
      outerWidth += imageGalleries.length * 164;
      outerWidth += productImages.length * 164;
      productImagesWrapper.style.width = outerWidth + 'px';
    }
  }

  uploadedProductImageEdit.addEventListener('click', () => {
    productImageFileInput.click();
  });

  // drag&dropで登録
  const addDragDropEvent = (targetElement: HTMLElement) => {
    targetElement.addEventListener('drop', (event) => {
      event.preventDefault();
      const file = (event.dataTransfer as DataTransfer).files[0];
      const dt = new DataTransfer();
      dt.items.add(file);
      productImageFileInput.files = dt.files;
      productImageFileInput.dispatchEvent(new Event('change'));
    });

    targetElement.addEventListener('dragover', (event) => {
      event.preventDefault();
      (event.dataTransfer as DataTransfer).dropEffect = 'copy';
    });

    targetElement.addEventListener('dragleave', (event) => {
      event.preventDefault();
    });
  }

  formDiv.addEventListener('drop', (event) => {
    event.preventDefault();
  });

  formDiv.addEventListener('dragover', (event) => {
    event.preventDefault();
    (event.dataTransfer as DataTransfer).dropEffect = 'copy';
  });


  const initialize = () => {
    productNameInput.addEventListener('keyup', debounce(() => {
      fetchProducts();
      fetchImageGalleries();
    }, 500));
    refreshProductImageInputAreaAndUploadedImage();
    addEventToImage(uploadedProductImage);
    fetchProducts();
    fetchImageGalleries();
    addDragDropEvent(productImageInputArea);
    addDragDropEvent(uploadedProductImage);
  }

  initialize();
});
